export const WHATSAPP_NUMBER = "905413521812";
export const WHATSAPP_DISPLAY = "+90 541 352 18 12";
export const PHONE_DISPLAY = "+90 533 318 94 56";
export const PHONE_NUMBER = "+905333189456";
export const COMPANY_EMAIL = "reservation@reemtravel.com.tr";
export const GOOGLE_MAPS_LINK = "https://maps.app.goo.gl/xdrJKhPDTWYN8Cqw9";
// Generic embed using company name search (no API key required)
export const GOOGLE_MAPS_EMBED =
  "https://www.google.com/maps?q=Reem+Travel+Tourism+Istanbul&output=embed";

export const LOGO_HEADER = "/brand/reem-group-header.webp";
export const LOGO_MARK = "/brand/favicon-192.png";

export const IMAGES = {
  hero: "/images/hero-coast.webp",
  heroSecondary: "/images/tour-istanbul.webp",
  sapanca: "/images/tour-sapanca.webp",
  cappadocia: "/images/tour-cappadocia.webp",
  antalya: "/images/antalya.webp",
  bodrum: "/images/bodrum.webp",
  marmaris: "/images/marmaris.webp",
  fethiye: "/images/fethiye.webp",
  kusadasi: "/images/kusadasi.webp",
  cesme: "/images/cesme.webp",
  vipTransfer: "/images/vip-transfer.webp",
  guide: "/images/travel-guide.webp",
};
